<template>
  <div :style="{ height: height + 'px', lineHeight: height + 'px' }" class="flex text-base font-bold sm:text-2xl">
    <slot name="prefix" />
    <div :class="$style.label" :style="labelStyle">
      <!-- eslint-disable -->
      <div v-for="(char, index) of label" :key="index" v-html="char"></div>
      <div>-</div>
      <div v-for="(char, index) of label" :key="index" v-html="char"></div>
    </div>
    <div>:</div>
    <div :class="$style.input" :style="{ lineHeight: height + 'px', ...inputStyle }" class="flex-grow px-4 mx-2">
      <slot />
    </div>
    <slot name="suffix" />
  </div>
</template>

<script>
export default {
  name: 'NHLabelNumber',
  props: {
    name: {
      type: String,
      required: true,
    },
    labelStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    height: {
      type: Number,
      required: false,
      default: 30,
    },
    inputStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      label: '',
    }
  },
  mounted() {
    this.label = this.partialCharacters(this.name)
  },
  methods: {
    partialCharacters(text) {
      const chars = []
      for (const char of text) {
        if (char !== '' && char !== ' ') {
          chars.push(char)
        }
      }
      return chars
    },
  },
}
</script>

<style lang="scss" module>
.label {
  color: #216b00;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.input {
  border-bottom: 2px solid #216b00;
  height: 100%;
}
</style>
